import React, { useState } from 'react'
import { Paperclip } from 'react-bootstrap-icons'
import { openDocument } from '../../../../libs/files/openDocument'
import Messaging from '../../../../libs/api/services/Messaging'

export default function AttachmentComponent({ attachments }) {
    const [show, setShow] = useState(false)

    const _handleDownloadAttachment = async (id, filename, memimeType) => {
        //var file = await GET_DOCUMENT(id)
        var file = await Messaging
            .GetAttachment(id);
        openDocument(file.data, file.mimeType, file.fileName)
    }
    return (
        attachments.length > 0
            ?
            <div className='position-relative'>
                <Paperclip
                    onClick={(e) => setShow(!show)}
                    style={{ cursor: 'pointer' }}
                    className='m-1'
                    size={18} />
                <ul className={'position-absolute bg-dark p-3 list-unstyled rounded '.concat(show ? 'd-block' : 'd-none')} style={{ width: '350px', right: '0px' }}>
                    {
                        attachments.map((a) => {
                            return (<li
                                onClick={(e) => _handleDownloadAttachment(a.id, a.fileName, a.mimeType)}
                                style={{ cursor: 'pointer' }}>{a.fileName}</li>)
                        })
                    }
                </ul>
            </div>
            :
            <></>
    )
}
